const LEGACY_UNSCOPED_MATCH_PATH_RE = /^\/match\/[^/]+$/;

function getDirectNotificationPath(notification) {
  const path = notification?.additionalAction?.url || notification?.action;
  return typeof path === 'string' && path.startsWith('/') ? path : null;
}

function normalizeMatchPath(path) {
  return LEGACY_UNSCOPED_MATCH_PATH_RE.test(path) ? `${path}/match` : path;
}

export function resolveNotificationActionPath(notification, fallbackLeagueSlug = null) {
  const directPath = getDirectNotificationPath(notification);
  if (!directPath) {
    return null;
  }

  const path = normalizeMatchPath(directPath);
  const leagueSlug = notification?.data?.leagueSlug || notification?.leagueSlug || fallbackLeagueSlug;

  if (path.startsWith('/match/')) {
    return leagueSlug ? `/${leagueSlug}${path}` : null;
  }

  return path;
}

// Shared action-to-path resolution for notification action buttons. Both the
// bell dropdown and the inbox page call this so new actions only need to be
// added once. Callers resolve leagueSlug and teamId themselves because each
// surface has its own way of doing that. Returns null for unknown actions,
// which means "do nothing" (no navigation, no mark-as-read).
export function resolveNotificationNavigationPath(action, { notification = null, leagueSlug = null, teamId = null } = {}) {
  switch (action) {
    case 'go_to_match':
      return resolveNotificationActionPath(notification, leagueSlug)
        || (leagueSlug ? `/${leagueSlug}/matches` : '/switch-league');
    case 'go_to_squad':
    case 'go_to_team':
      return leagueSlug && teamId
        ? `/${leagueSlug}/team-pitch/${teamId}`
        : (leagueSlug ? `/${leagueSlug}/table` : '/switch-league');
    case 'sign_contract':
      return leagueSlug ? `/${leagueSlug}/transfers/contracts` : '/switch-league';
    case 'go_to_transfers':
      return leagueSlug ? `/${leagueSlug}/transfers-players` : '/switch-league';
    case 'go_to_league':
      return leagueSlug ? `/${leagueSlug}/table` : '/switch-league';
    default:
      return null;
  }
}
